import React from "react";

export default () => (
  <div className="header">
    <img src={`images/logos/${process.env.REACT_APP_STREAM_KEY}-logo.png`} class="logo" />
    <div className="blurb">Powered by <a onClick={() => this.setState({modalOpen: true})}>DomeStream</a></div>
  </div>
);